import vuetify from '@/plugins/vuetify'
import i18n from '@/plugins/i18nPlugin'

import createPersistedState from 'vuex-persistedstate'

const setDocumentLocale = () => {
  document.querySelector('html').setAttribute('lang', i18n.locale)
  document.title = i18n.t('APP_TITLE') + ' | CPU'
}

const store = createPersistedState({
  key: 'preferences',
  paths: ['preferences.locale', 'preferences.displayMode'],
  fetchBeforeUse: true,
  rehydrated: store => {
    i18n.locale = store.state.preferences.locale
    setDocumentLocale()
  }
})

const state = () => ({
  locale: null,
  displayMode: null
})

const getters = {
  locale: state => state.locale,
  locales: () => {
    return [
      {
        value: 'fr',
        label: 'Français'
      },
      {
        value: 'en',
        label: 'English'
      }
    ]
  },
  displayMode: state => state.displayMode
}

const actions = {
  setLocale: ({ commit }, locale) => {
    commit('setLocale', locale)
  },
  setDisplay: ({ commit }, display) => {
    commit('setDisplay', display)
  },
  initialize: ({ state, commit }) => {
    commit('setLocale', state.locale || i18n.locale)
    const displayModeIsSet = typeof state.displayMode !== 'undefined' && state.displayMode !== null
    if (!displayModeIsSet) {
      const useMode = vuetify.framework.breakpoint.mdAndDown ? 0 : 1
      commit('setDisplay', useMode)
    }
  }
}

const mutations = {
  setLocale: (state, payload) => {
    state.locale = payload
    i18n.locale = state.locale
    vuetify.framework.lang.current = state.locale
    setDocumentLocale()
  },
  setDisplay: (state, payload) => {
    state.displayMode = payload
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default {
  module: module,
  store
}
